/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum CreatedUpdatedDeletedByType {
    System = 'System',
    User = 'User',
    CustomerPerson = 'CustomerPerson',
    Person = 'Person',
    External = 'External',
    Insurance = 'Insurance'
  }

    export const CreatedUpdatedDeletedByTypeTranslocoMap: Record<CreatedUpdatedDeletedByType, string> = {
    [CreatedUpdatedDeletedByType.System]: 'createdUpdatedDeletedByType.system',
    [CreatedUpdatedDeletedByType.User]: 'createdUpdatedDeletedByType.user',
    [CreatedUpdatedDeletedByType.CustomerPerson]: 'createdUpdatedDeletedByType.customerPerson',
    [CreatedUpdatedDeletedByType.Person]: 'createdUpdatedDeletedByType.person',
    [CreatedUpdatedDeletedByType.External]: 'createdUpdatedDeletedByType.external',
    [CreatedUpdatedDeletedByType.Insurance]: 'createdUpdatedDeletedByType.insurance',
    };

    export const CreatedUpdatedDeletedByTypeOptions = [
  { value: CreatedUpdatedDeletedByType.System, labelKey: 'createdUpdatedDeletedByType.system' },
  { value: CreatedUpdatedDeletedByType.User, labelKey: 'createdUpdatedDeletedByType.user' },
  { value: CreatedUpdatedDeletedByType.CustomerPerson, labelKey: 'createdUpdatedDeletedByType.customerPerson' },
  { value: CreatedUpdatedDeletedByType.Person, labelKey: 'createdUpdatedDeletedByType.person' },
  { value: CreatedUpdatedDeletedByType.External, labelKey: 'createdUpdatedDeletedByType.external' },
  { value: CreatedUpdatedDeletedByType.Insurance, labelKey: 'createdUpdatedDeletedByType.insurance' },
    ];

